import { Badge, Button, Heading } from "~/ui";

interface HeaderProps {
  title: string;
  badgeText?: string;
  button?: {
    text: string;
    onClick: () => void;
  };
}

export const Header = ({ title, badgeText, button }: HeaderProps) => {
  return (
    <div className="mb-4 flex w-full flex-row items-center justify-between gap-3">
      <div className="flex flex-row items-center gap-2">
        <Heading>{title}</Heading>
        {badgeText && <Badge text={badgeText} color="light" type="solid" />}
      </div>
      {button && (
        <div>
          <Button text={button.text} onClick={button.onClick} />
        </div>
      )}
    </div>
  );
};
